// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"4f5d1a77","171":"8d8651f9","432":"33cbddc3","994":"46d6ca3c"}[chunkId] + ".chunk.js";
};